import React from "react";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import styles from "./registration_box.module.scss";
import Image from "next/image";

const RegistrationBox = () => {
  return (
    <div className={styles.choose_register_wrapper}>
      <div className={styles.register}>
        <div className={styles.register_title}>The Complete Platform</div>
        <p className={styles.register_sub_text}>
          With our AI-driven profile matching We find the universities that best
          fit you
        </p>
        <div className={styles.image_wrapper_mobile}>
          <Image
            width={1000}
            height={400}
            src={getAssets("assets/images/why-choose.jpg")}
            alt="why choose"
            className="border"
          />
        </div>

        <Link legacyBehavior href="/signin">
          <a className="btn btn-secondary btn-md">Register Now</a>
        </Link>
      </div>
      <div className={styles.image_wrapper}>
        <Image
          width={1000}
          height={400}
          src={getAssets("assets/images/why-choose.jpg")}
          alt="why choose"
        />
      </div>
    </div>
  );
};

export default RegistrationBox;
